import React from "react";
import tw, { styled } from "twin.macro";
import YoutubeIcon from "./../images/youtube.svg";
import TiktokIcon from "./../images/tiktok.svg";
import TwitterIcon from "./../images/twitter.svg";
import InstagramIcon from "./../images/instagram.svg";
import FacebookIcon from "./../images/facebook.svg";

const Container = styled.div`
  ${tw`mt-4`}

  ${({ noMargin }) => noMargin && tw`mt-0`}
  ${({ gridDisplay }) =>
    gridDisplay ? tw`grid grid-cols-2 gap-4 w-fit` : tw`flex items-center`}
`;

const ExternalLink = styled.a`
  ${tw`aspect-square rounded-lg flex justify-center items-center`}
  background-color: ${(props) => props.background};
  width: ${(props) => props.width};
  ${({ gridDisplay }) => !gridDisplay && tw`[&:not(:last-child)]:mr-4`}
`;

const IconWrapper = styled.div`
  ${tw`w-6 h-6`}
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  svg {
    fill: ${(props) => props.color};
  }
`;

const SocialMedia = ({
  bgWidth,
  iconWidth,
  iconHeight,
  iconColor,
  backgroundColor,
  noMargin,
  gridDisplay,
  socialMediaData = {},
}) => (
  <Container noMargin={noMargin} gridDisplay={gridDisplay}>
    {socialMediaData.instagram && (
      <ExternalLink
        href={socialMediaData.instagram}
        target="_blank"
        aria-label="Instagram Page"
        background={backgroundColor}
        width={bgWidth}
        gridDisplay={gridDisplay}
      >
        <IconWrapper width={iconWidth} height={iconHeight} color={iconColor}>
          <InstagramIcon />
        </IconWrapper>
      </ExternalLink>
    )}

    {socialMediaData.twitter && (
      <ExternalLink
        href={socialMediaData.twitter}
        target="_blank"
        aria-label="Twitter Profile"
        background={backgroundColor}
        width={bgWidth}
        gridDisplay={gridDisplay}
      >
        <IconWrapper width={iconWidth} height={iconHeight} color={iconColor}>
          <TwitterIcon />
        </IconWrapper>
      </ExternalLink>
    )}

    {socialMediaData.facebook && (
      <ExternalLink
        href={socialMediaData.facebook}
        target="_blank"
        aria-label="Facebook Page"
        background={backgroundColor}
        width={bgWidth}
        gridDisplay={gridDisplay}
      >
        <IconWrapper width={iconWidth} height={iconHeight} color={iconColor}>
          <FacebookIcon />
        </IconWrapper>
      </ExternalLink>
    )}

    {socialMediaData.tiktok && (
      <ExternalLink
        href={socialMediaData.tiktok}
        target="_blank"
        aria-label="Tiktok"
        background={backgroundColor}
        width={bgWidth}
        gridDisplay={gridDisplay}
      >
        <IconWrapper width={iconWidth} height={iconHeight} color={iconColor}>
          <TiktokIcon />
        </IconWrapper>
      </ExternalLink>
    )}

    {socialMediaData.youtube && (
      <ExternalLink
        href={socialMediaData.youtube}
        target="_blank"
        aria-label="Youtube Channel"
        background={backgroundColor}
        width={bgWidth}
        gridDisplay={gridDisplay}
      >
        <IconWrapper width={iconWidth} height={iconHeight} color={iconColor}>
          <YoutubeIcon />
        </IconWrapper>
      </ExternalLink>
    )}
  </Container>
);

export default SocialMedia;
